<template>
  <div class="ts-relative ts-w-full ts-h-full">
    <div class="container" v-if="resources.length">
      <div class="wrapper">
        <ul class="sessions">
          <li v-for="(r, index) in resources" :key="index">
            <div class="ts-font-robot ts-text-lg ts-text-blue-800">
              {{ r.updated_at }}
            </div>
            <div class="ts-w-full">
              <div class="ts-flex ts-space-x-2 ts-items-center">
                <Icon type="ios-contacts" size="25" class="ts-text-gray-600" />
                <p
                  class="ts-mb-0 ts-font-heading-font ts-font-semibold ts-text-gray-600"
                >
                  {{ r.updated_by_name }}
                </p>
              </div>
              <div
                class="ts-font-robot ts-mb-0 ts-text-base ts-w-full"
                v-html="r.description"
              ></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="resources.length && meta.current_page != meta.last_page">
      <button
        @click.prevent="fetchData()"
        class="ts-bg-blue-100 hover:ts-bg-blue-200 ts-duration-200 ts-transition-all ts-text-center ts-py-2 ts-w-full ts-rounded-md ts-font-robot"
      >
        {{ $t('projectProfile.loadMore') }}
      </button>
    </div>
    <div
      class="ts-w-full ts-h-full ts-flex ts-items-center ts-justify-center"
      v-if="!resources.length"
    >
      <img
        src="@/assets/no_data.png"
        class="ts-h-48 ts-object-contain"
        alt=""
      />
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      loading: true,
      resources: [],
      meta: {
        current_page: 0,
        last_page: 0,
        total: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['history']),
    fetchData() {
      this.loading = true
      let id = this.$route.params.id
      this.history({
        page: this.meta.current_page + 1,
        perPage: 15,
        filter: {
          filter_by_id: id
        }
      })
        .then(response => {
          this.resources.push(...response.data)
          this.meta = response.meta
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
ul,
li {
  list-style: none;
  padding: 0;
}

.container {
  display: flex;
  align-items: center;
}
.sessions {
  margin-top: 2rem;
  border-radius: 12px;
  position: relative;
}
li {
  padding-bottom: 1.5rem;
  border-left: 1px solid #211f6e;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;
  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }
  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: white;
    border: 1px solid #4e5ed3;
    box-shadow: 3px 3px 0px #bab5f8;
    box-shadow: 3px 3px 0px #bab5f8;
    border-radius: 50%;
    position: absolute;
    left: -10px;
    top: 0px;
  }
}
</style>
